import React from 'react';
import ReactDOM from "react-dom";
import clsx from 'clsx';
// material ui
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles';
// components
import Debrief from './Debrief/Debrief.js';
import Theme from './Theme.js';

const widgets = window.widgets;
const posts = window.custom_posts;

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
});

function App() {
  const classes = useStyles();
  const containerClasses = clsx({
    [classes.root] : true,
  })

  return (
    <div id="root" className={containerClasses}>
      <Debrief widgets={{...widgets, ...posts}} />
    </div>
  )
}

const wrapper = document.getElementById("debrief");
ReactDOM.render(
  <MuiThemeProvider theme={Theme}>
    <App />
  </MuiThemeProvider>
, wrapper);
